import { useQuery } from "@tanstack/react-query";
import { appointmentService } from "..";

const useGetMerchantServices = (enabled: boolean = true) =>
  useQuery({
    queryKey: ["getMerchantServices"],
    queryFn: () => appointmentService.getMerchantServices(),
    select: (res) => res,
    enabled: enabled,
  });

export { useGetMerchantServices };
